/**
 * The URL to report to analytics for a navigation: path and query only. The
 * fragment is dropped because a return from the DGB cart-session round-trip
 * carries the session bearer id there (`#fcsid=…`), which must never be
 * stored in third-party analytics.
 */
export function analyticsPagePath(url: string): string {
  return url.split("#")[0];
}
